import type { Theme } from '@mui/material/styles'

const MuiLink = (baseTheme: Theme) => ({
  styleOverrides: {
    root: {
      color: 'inherit',
      textDecorationColor: 'currentColor',
      fontWeight: 500,

      '&:hover': {
        color: baseTheme.palette.neutral.main,
        cursor: 'pointer',
      },
      '&:focus-visible': {
        outline: `max(2px, 0.08em) solid ${baseTheme.palette.primary.main}`,
      },
    },
  },
})

export default MuiLink
